module.exports = "<ng-container *ngIf=\"item\">\n    <ng-container>\n        <row-header [row$]=\"item\" [showCount]=\"true\" [fullCopy]=\"true\" [showSeasonButton]=\"true\" class=\"featured container header\" [actionMessage]=\"enablePlayAll && 'Play All'\"></row-header>\n        <div class=\"season-list\">\n            <episode-carousel [slides]=\"slides\"></episode-carousel>\n        </div>\n    </ng-container>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/series/season-list/season-list.template.html
// module id = 805
// module chunks = 2